module.exports = __webpack_public_path__ + "media/net.e30534ab.wav";